import { render, staticRenderFns } from "./AccountsPage.vue?vue&type=template&id=464fe81c&"
import script from "./AccountsPage.vue?vue&type=script&lang=js&"
export * from "./AccountsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('464fe81c')) {
      api.createRecord('464fe81c', component.options)
    } else {
      api.reload('464fe81c', component.options)
    }
    module.hot.accept("./AccountsPage.vue?vue&type=template&id=464fe81c&", function () {
      api.rerender('464fe81c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/administration/AccountsPage.vue"
export default component.exports